import { render } from "./Money.vue?vue&type=template&id=d8636312&scoped=true"
import script from "./Money.vue?vue&type=script&lang=js"
export * from "./Money.vue?vue&type=script&lang=js"

import "./Money.vue?vue&type=style&index=0&id=d8636312&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8636312"]])

export default __exports__